import React, { ReactElement, FunctionComponent, memo, useCallback } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Image from '../../../BaseComponents/Image'
import { FontelloIconType } from '../../../themes/FontelloIconType'
import PlayerImage from '../../../BaseComponents/Image/Player'
import TeamImage from '../../../BaseComponents/Image/Team'
import { TintColor } from '../../../BaseComponents/Image/ImageInterfaces'

export type FontelloIconTypeExtended = FontelloIconType | 'red-card' | 'yellow-card'

export type FontSize = string | number

type NavigationListImageProps = {
    imageType?: 'none' | 'image' | 'icon'
    imageUrl?: string
    alt?: string
    imageIcon?: FontelloIconTypeExtended
    iconSize?: FontSize
    categoryType?: 'PLAYER' | 'TEAM' | 'AUTHOR'
    tintColor?: TintColor
}

type IconProps = {
    imageIcon: FontelloIconTypeExtended
    fontSize?: FontSize
    color?: string
    padding?: string | number
}

const Icon: FunctionComponent<IconProps> = ({
    imageIcon,
    fontSize = '21px',
    padding = 1,
    color,
}): ReactElement => {
    if (imageIcon === 'yellow-card') {
        return (
            <FontelloIcon
                name="card-active"
                fontSize={fontSize}
                padding={padding}
                color="#f8e833"
            />
        )
    } else if (imageIcon === 'red-card') {
        return (
            <FontelloIcon
                name="card-active"
                fontSize={fontSize}
                padding={padding}
                color="#e11b3c"
            />
        )
    }
    return (
        <FontelloIcon
            name={imageIcon}
            fontSize={fontSize}
            padding={padding}
            color={color || 'onyx-5'}
        />
    )
}

const NavigationListImage: FunctionComponent<NavigationListImageProps> = ({
    imageType = 'none',
    imageUrl,
    alt,
    imageIcon,
    iconSize,
    tintColor,
    categoryType,
}): ReactElement | null => {
    const getImageComponent = useCallback(() => {
        if (categoryType === 'PLAYER') {
            return <PlayerImage imageUrl={imageUrl} alt={alt} size="S" width={25} />
        } else if (categoryType === 'TEAM') {
            return <TeamImage imageUrl={imageUrl} alt={alt} size="S" width={25} />
        }
        return (
            <Grid noExpand center padding={1} borderRadius={1} backgroundColor="pearl-4">
                <Image
                    imageUrl={imageUrl}
                    width={23}
                    aspectRatio="1:1"
                    size="S"
                    tintColor={tintColor}
                    alt={alt}
                />
            </Grid>
        )
    }, [categoryType, imageUrl, alt, tintColor])

    if (imageType === 'icon' && imageIcon) {
        return (
            <Grid noExpand marginLeft={5} marginRight={4}>
                <Icon
                    imageIcon={imageIcon}
                    fontSize={iconSize}
                    color={tintColor === 'white' ? 'WHITE' : undefined}
                />
            </Grid>
        )
    }

    if (imageType === 'image' && (imageUrl || categoryType)) {
        return (
            <Grid noExpand marginLeft={5} marginRight={4}>
                {getImageComponent()}
            </Grid>
        )
    }

    return null
}

export default memo(NavigationListImage)
